import { render, staticRenderFns } from "./share.vue?vue&type=template&id=2a1addd6&scoped=true&"
import script from "./share.vue?vue&type=script&lang=js&"
export * from "./share.vue?vue&type=script&lang=js&"
import style0 from "./share.vue?vue&type=style&index=0&id=2a1addd6&prod&lang=scss&scoped=true&"
import style1 from "./share.vue?vue&type=style&index=1&id=2a1addd6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1addd6",
  null
  
)

export default component.exports